import DataRow, { roundInvoiceVal } from "../DataRow";

describe("DataRow", () => {
  describe("roundInvoiceVal", () => {
    it("should round to 2 decimal places", () => {
      expect(roundInvoiceVal(10.125)).toBe(10.13);
      expect(roundInvoiceVal(10.124)).toBe(10.12);
    });

    it("should handle floating point precision errors", () => {
      // 0.1 + 0.2 = 0.30000000000000004 in JS
      const result = 0.1 + 0.2;
      expect(roundInvoiceVal(result)).toBe(0.3);
    });

    it("should handle null/undefined", () => {
      expect(roundInvoiceVal(null)).toBe(0);
      expect(roundInvoiceVal(undefined)).toBe(0);
    });
  });

  describe("freightWarehousing", () => {
    it("using whole tolerance: returns correct notProcessed", () => {
      const invoice = {
        freightWarehousingMaximum: 100,
        freightWarehousingAssetsPaid: 175,
        freightWarehousingDepositsPaid: 100,
        freightWarehousingOtherAssetsPaid: 0,
        freightWarehousingOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "freightWarehousing");

      expect(dataRow.assetsPaid).toBe(175);
      expect(dataRow.assetsToDate).toBe(175);
      expect(dataRow.depositsPaid).toBe(100);
      expect(dataRow.depositsToDate).toBe(100);
      expect(dataRow.rawNotProcessed).toBe(-175);
      expect(dataRow.notProcessed).toBe(0);

      expect(dataRow.notProcessedAssetsPaid).toBe(175);
      expect(dataRow.notProcessedDepositsPaid).toBe(100);
    });

    it("using partial tolerance: returns correct notProcessed", () => {
      const invoice = {
        freightWarehousingMaximum: 100,
        freightWarehousingAssetsPaid: 75,
        freightWarehousingDepositsPaid: 100,
        freightWarehousingOtherAssetsPaid: 0,
        freightWarehousingOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "freightWarehousing");

      expect(dataRow.assetsPaid).toBe(75);
      expect(dataRow.assetsToDate).toBe(75);
      expect(dataRow.depositsPaid).toBe(100);
      expect(dataRow.depositsToDate).toBe(100);
      expect(dataRow.rawNotProcessed).toBe(-75);
      expect(dataRow.notProcessed).toBe(0);

      expect(dataRow.notProcessedAssetsPaid).toBe(175);
      expect(dataRow.notProcessedDepositsPaid).toBe(200);
    });

    it("using no tolerance: returns correct notProcessed", () => {
      const invoice = {
        freightWarehousingMaximum: 100,
        freightWarehousingAssetsPaid: 0,
        freightWarehousingDepositsPaid: 100,
        freightWarehousingOtherAssetsPaid: 0,
        freightWarehousingOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "freightWarehousing");

      expect(dataRow.assetsPaid).toBe(0);
      expect(dataRow.assetsToDate).toBe(0);
      expect(dataRow.depositsPaid).toBe(100);
      expect(dataRow.depositsToDate).toBe(100);
      expect(dataRow.rawNotProcessed).toBe(0);
      expect(dataRow.notProcessed).toBe(0);

      expect(dataRow.notProcessedAssetsPaid).toBe(175);
      expect(dataRow.notProcessedDepositsPaid).toBe(275);
    });
  });

  describe("precision calculations", () => {
    it("should handle precision in net calculations", () => {
      const invoice = {
        merchandiseMaximum: 1000,
        merchandiseAssetsPaid: 333.33,
        merchandiseDepositsPaid: 333.33,
        merchandiseOtherAssetsPaid: 0,
        merchandiseOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "merchandise");

      expect(dataRow.assetsPaid).toBe(333.33);
      expect(dataRow.depositsPaid).toBe(333.33);
      expect(dataRow.net).toBe(666.66);
      expect(dataRow.netToDate).toBe(666.66);
      expect(dataRow.rawNotProcessed).toBe(333.34);
    });

    it("should handle precision in assetsToDate with decimals", () => {
      const invoice = {
        taxMaximum: 100,
        taxAssetsPaid: 8.33,
        taxDepositsPaid: 0,
        taxOtherAssetsPaid: 8.34,
        taxOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "tax");

      expect(dataRow.assetsPaid).toBe(8.33);
      expect(dataRow.assetsToDate).toBe(16.67);
      expect(dataRow.depositsToDate).toBe(0);
      expect(dataRow.netToDate).toBe(16.67);
      expect(dataRow.rawNotProcessed).toBe(83.33);
    });

    it("should handle multiple small additions without accumulating errors", () => {
      const invoice = {
        installMaximum: 10000,
        installAssetsPaid: 0.1 + 0.2, // Would be 0.30000000000000004 in JS
        installDepositsPaid: 0.3,
        installOtherAssetsPaid: 0,
        installOtherDepositsPaid: 0,
      };

      const dataRow = new DataRow(invoice, "install");

      // Should cleanly round to 0.3 and 0.3
      expect(dataRow.assetsPaid).toBe(0.3);
      expect(dataRow.depositsPaid).toBe(0.3);
      expect(dataRow.net).toBe(0.6);
      expect(dataRow.netToDate).toBe(0.6);
    });

    it("should handle negative tolerance calculations precisely", () => {
      const invoice = {
        overageMaximum: 500,
        overageAssetsPaid: 100.33,
        overageDepositsPaid: 200.67,
        overageOtherAssetsPaid: 150.5,
        overageOtherDepositsPaid: 100.25,
      };

      const dataRow = new DataRow(invoice, "overage");

      expect(dataRow.net).toBe(301);
      expect(dataRow.assetsToDate).toBe(250.83);
      expect(dataRow.depositsToDate).toBe(300.92);
      expect(dataRow.netToDate).toBe(551.75);
      expect(dataRow.rawNotProcessed).toBe(-51.75);
    });
  });
});
